// 通用校验非空规则
/**
 * @param {string} type 要校验字段类型, 如 string, array, number
 * @param  {string} errorMsg 校验失败时错误信息内容
 */
function NotNull(type, errorMsg) {
    this.type = type;
    this.required = true;
    this.asyncValidator = (rule, value) => {
        console.log('--NotNull',type,errorMsg,rule,value);
        return new Promise((resolve, reject) => {
            if (typeof value == 'string' || value.constructor == String) {
                // 如果是字符串类型数据去除两侧空格再校验
                value = value.trim();
            }
            if (!value || value == 'undefined') {
                reject(errorMsg);
                return;
            }
            if (Array.isArray(value)) {
                // 不允许空数组
                if (value.length == 0) {
                    reject(errorMsg);
                    return;
                }
            }
            resolve();
        });
    }
}

// 使用自定义校验规则
/**
 * @param {string} type 要校验字段类型, 如 string, array, number
 * @param {function} processor 规则函数, 校验错误时返回错误信息, 否则无返回值
 *         value => {
 *             if (value == "undefined") {
 *                 let errMsg = "";
 *                 return errMsg;
 *             }
 *         }
 * @param {boolean} [required] 是否必填 true | false
 */
function Validated(type, processor, required) {
    if (!required) {
        required = false;
    }
    this.type = type;
    this.required = required;
    this.asyncValidator = (rule, value) => {
        return new Promise((resolve, reject) => {
            if (!required && !value) {
                // 非必填并且value不存在时, 不执行校验规则
                resolve();
                return;
            }
            let error = processor(value);
            if (!error) {
                resolve();
            } else {
                reject(error);
            }
        });
    }
}

/**
 * 校验字符串长度规则
 * @param {object} args 校验字符串长度需要传入的参数对象有6个属性
 * @param {boolean} [args.required] 是否必填 boolean
 * @param {int} [args.min] 字符串最短长度, 不填写将不限制最短长度
 * @param {int} args.max 字符串最大长度
 * @param {string} [args.errorMsg] 表单必填时,无数据时报错信息
 * @param {string} [args.minErrorMsg] 小于最小长度报错信息
 * @param {string} args.maxErrorMsg 大于最大长度报错信息
 * @param {function} [args.processor] 校验长度后额外的校验规则
 * @returns {object} {Validated}
 * @constructor
 */
function Length(args) {
    return new Validated('string', value => {
        if (typeof value == 'string' || value.constructor == String) {
            // 如果是字符串类型数据去除两侧空格再校验
            value = value.trim();
        }
        // 如果必填并且没填写时返回错误信息
        if (!value || value == "undefined") {
            if (args.required) {
                return args.errorMsg;
            }
            if (!args.required) {
                // 非必填情况
                return;
            }
        }
        if (!args.min || args.min == "undefined") {
            args.min = 0;
        }
        if (String(value).length < args.min) {
            return args.minErrorMsg;
        }
        if (String(value).length > args.max) {
            return args.maxErrorMsg;
        }
        if (args.processor) {
            // 如果额外校验存在, 执行对应的校验方法
            return args.processor(value);
        }
    }, args.required);
}

export {
    NotNull,
    Validated,
    Length
};
